import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { API_URL } from '../../config/apiEndpoints';
import Moment from "react-moment";
import 'moment/locale/ro';
import {Link} from 'react-router-dom';
import {slugify} from '../../helpers/general.helper';
import Favorite from '../favorite/favorite.component';
import Parser from "html-react-parser";
import Spinner from "../spinner/spinner.component";

class TagListItem extends Component {

    render() {
        return (
            <Fragment>
                {this.props.loading !== 0 ? <Spinner /> : ''}
                <div className="row tag-item">
                    <div className="col-12 col-sm-2 image-holder">
                        <Link to={`/stire/${this.props.card.film_id}/${slugify(this.props.card.film_title)}`} className="white-text">
                            <img alt={'Film'} src={ API_URL + this.props.card.film_poster } />
                        </Link>
                    </div>
                    <div className="col-12 col-sm-10 list-view">
                        <div className="movie-item-list-view">
                            <div className="col-12 title-holder">
                                <span className="title-item">
                                    <Link to={`/stire/${this.props.card.film_id}/${slugify(this.props.card.film_title)}`} className="white-text">
                                        { this.props.card.film_title }
                                    </Link>
                                </span>
                                <p className="article-date dark-grey-text">Scris de { this.props.card.article_author_first_name + ' ' + this.props.card.article_author_last_name }</p>
                                <p className="article-summary">{ Parser(this.props.card.article_summary.substr(0, 200)) }...</p>
                            </div>

                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests
});
export default connect(mapStateToProps, {})(TagListItem);





// WEBPACK FOOTER //
// ./src/SHARED/components/taglistitem/taglistitem.component.js